var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPdf = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7C12.9 7 12 7.9 12 9V37C12 38.1 12.9 38.9999 14 38.9999H34C35.1 38.9999 36 38.1 36 37V15L28 7H14Z",
    fill: "#F2F3F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9C12.5 8.17614 13.1761 7.5 14 7.5H27.7929L35.5 15.2071V37C35.5 37.8238 34.8238 38.4999 34 38.4999H14C13.1761 38.4999 12.5 37.8238 12.5 37V9Z",
    stroke: "#7F8C99",
    strokeOpacity: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30 15H36L28 7V13C28 14.1 28.9 15 30 15Z",
    fill: "#BBC1C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M36 21L30 15H36V21Z",
    fill: "#BBC1C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 33C32 33.55 31.55 34 31 34H9C8.45 34 8 33.55 8 33V23C8 22.45 8.45 22 9 22H31C31.55 22 32 22.45 32 23V33Z",
    fill: "#EE2D24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31 34H12V35H31C31.55 35 32 34.55 32 34V33C32 33.55 31.55 34 31 34Z",
    fill: "#BBC1C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6304 28.7624H12.8276V27.9423H14.6304C14.9443 27.9423 15.198 27.8984 15.3914 27.8104C15.5849 27.7225 15.726 27.6016 15.8148 27.4478C15.9067 27.2912 15.9527 27.1126 15.9527 26.9121C15.9527 26.7225 15.9067 26.5453 15.8148 26.3805C15.726 26.2129 15.5849 26.0783 15.3914 25.9766C15.198 25.875 14.9443 25.8242 14.6304 25.8242H13.1939V31H12V25H14.6304C15.1663 25 15.6213 25.0824 15.9955 25.2473C16.3729 25.4093 16.6599 25.6346 16.8565 25.9231C17.0531 26.2088 17.1514 26.5357 17.1514 26.9038C17.1514 27.2912 17.0531 27.6236 16.8565 27.9011C16.6599 28.1786 16.3729 28.3915 15.9955 28.5398C15.6213 28.6882 15.1663 28.7624 14.6304 28.7624Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2336 31H18.7543L18.7638 30.1799H20.2336C20.6617 30.1799 21.0201 30.0989 21.3086 29.9368C21.6004 29.7747 21.8192 29.5426 21.965 29.2404C22.1141 28.9382 22.1886 28.5783 22.1886 28.1607V27.8352C22.1886 27.511 22.1458 27.2239 22.0602 26.9739C21.9777 26.7239 21.854 26.5137 21.6891 26.3434C21.5274 26.1731 21.3276 26.044 21.0898 25.956C20.8552 25.8681 20.584 25.8242 20.2764 25.8242H18.7258V25H20.2764C20.7362 25 21.1564 25.0673 21.5369 25.2019C21.9175 25.3338 22.2457 25.5247 22.5215 25.7747C22.8006 26.0247 23.0146 26.3242 23.1637 26.6731C23.3127 27.022 23.3872 27.4121 23.3872 27.8434V28.1607C23.3872 28.592 23.3127 28.9821 23.1637 29.331C23.0146 29.6799 22.8006 29.9794 22.5215 30.2294C22.2425 30.4766 21.9095 30.6676 21.5227 30.8022C21.139 30.9341 20.7093 31 20.2336 31ZM19.4155 25V31H18.2216V25H19.4155Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7798 25V31H24.5859V25H25.7798ZM28.6052 27.625V28.4451H25.4754V27.625H28.6052ZM29 25V25.8242H25.4754V25H29Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPdf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pdf.b474f739.svg";
export { ForwardRef as ReactComponent };